import useSWR from 'swr'
import { myAxios } from './request'

//@ts-ignore
export default function useRequest<T>(request1, { initialData, ...config } = {}) {
  return useSWR<T>(
    request1 && JSON.stringify(request1),
    () => myAxios(request1 || {}).then<T>(response => response.data.result),
    {
      ...config,
      initialData: initialData
    }
  ) 
}